import { MdOutlinePeople, MdOutlineAssignment } from 'react-icons/md';
import { TbSettings2 } from 'react-icons/tb';
import { MdOutlineCheckCircle, MdOutlinePayment } from 'react-icons/md';
import { TbReceipt } from 'react-icons/tb';
import { AiOutlineClockCircle } from 'react-icons/ai';
import { PiRepeatFill } from 'react-icons/pi';
import { IoClose } from 'react-icons/io5';

interface StatusConfig {
  icon: React.ReactNode;
  label: string;
  className: string;
}

const STATUS_CONFIG: Record<string, StatusConfig> = {
  ASSIGNED: {
    icon: <MdOutlinePeople className="text-sm" />,
    label: 'Assigned',
    className: 'bg-sky-100 text-sky-700 border border-sky-300',
  },
  IN_PROGRESS: {
    icon: <TbSettings2 className="text-sm" />,
    label: 'In Progress',
    className: 'bg-violet-100 text-violet-700 border border-violet-300',
  },
  REVIEW: {
    icon: <MdOutlineAssignment className="text-sm" />,
    label: 'For Review',
    className: 'bg-orange-100 text-orange-700 border border-orange-300',
  },
  DELIVERED: {
    icon: <MdOutlineCheckCircle className="text-sm" />,
    label: 'Delivered',
    className: 'bg-green-100 text-green-700 border border-green-300',
  },
  BILLED: {
    icon: <TbReceipt className="text-sm" />,
    label: 'Billed',
    className: 'bg-emerald-100 text-emerald-700 border border-emerald-300',
  },
  PAYMENT_RECEIVED: {
    icon: <MdOutlinePayment className="text-sm" />,
    label: 'Payment Received',
    className: 'bg-teal-100 text-teal-700 border border-teal-300',
  },
  HOLD: {
    icon: <AiOutlineClockCircle className="text-sm" />,
    label: 'On Hold',
    className: 'bg-yellow-100 text-yellow-700 border border-yellow-300',
  },
  REOPEN: {
    icon: <PiRepeatFill className="text-sm" />,
    label: 'Reopen',
    className: 'bg-purple-100 text-purple-700 border border-purple-300',
  },
  CANCELLED: {
    icon: <IoClose className="text-sm" />,
    label: 'Cancelled',
    className: 'bg-red-100 text-red-700 border border-red-300',
  },
  UNASSIGNED: {
    icon: <MdOutlinePeople className="text-sm" />,
    label: 'Unassigned',
    className: 'bg-gray-100 text-gray-600 border border-gray-300',
  },
};

interface Props {
  status: string;
}

const TaskStatusBadge: React.FC<Props> = ({ status }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG[status?.toUpperCase()];
  if (!config) {
    return (
      <span className="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600 border border-gray-300 w-fit">
        {status}
      </span>
    );
  }

  return (
    <span className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium w-fit ${config.className}`}>
      {config.icon}
      {config.label}
    </span>
  );
};

export default TaskStatusBadge;
